import React, { useEffect, useState, useRef } from "react";
import NavBar, { infoUtente, loadNav } from "../../visualComponents/NavBarManager.js";
import ToggleSwitch from "../../visualComponents/ToggleSwitch.js";
import { useNavigate } from "react-router-dom";
import { ArrowUpAZ, ArrowDownAZ, Pen, Trash2, Eye, EyeClosed, X, History, CircleHelp } from "lucide-react";
import Loader from "../../visualComponents/Loader.js";
import Tooltip from "../../components/Tooltip.js";

let selectAziende = [];
let isLoading = false;

const PopUpChangePassword = ({ isVisible, setIsVisible, data }) => {
    const [nuovaPassword, setNuovaPassword] = useState("");
    const [isNuovaPasswordVisible, setIsNuovaPasswordVisible] = useState(false);
    const [confermaPassword, setConfermaPassword] = useState("");
    const [isConfermaPasswordVisible, setIsConfermaPasswordVisible] = useState(false);
    const inputRefs = useRef([]);

    const closeModal = () => {
        setIsVisible(false);
    };

    const handleConferma = async () => {
        if (!checkPassword(nuovaPassword)) {
            alert('La nuova password non rispetta i requisiti');
            setNuovaPassword('');
            setConfermaPassword('');
            return;
        }

        if (nuovaPassword !== confermaPassword) {
            alert('Le password non coincidono');
            setNuovaPassword('');
            setConfermaPassword('');
            return;
        }

        try {
            isLoading = true;
            const response = await fetch('/aggiornaPassword', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    ID: data["ID"],
                    Password: nuovaPassword
                })
            });
            if (response.status === 500) {
                const responseData = await response.json();
                alert(responseData.error);
                console.error(responseData.error);
            } else {
                isLoading = false;
                window.location.reload();
            }
        } catch (error) {
            alert("Errore nel cambio password, riprova più tardi.");
            console.error(error);
        }
    };

    const checkPassword = (password) => {
        let check = true;
        const uppercasePattern = /[A-Z]/;
        const lowercasePattern = /[a-z]/;
        const specialCharPattern = /[!@#$%^&*(),.?":{}|<>]/;
        const numberPattern = /[0-9]/;

        if (!uppercasePattern.test(password)) {
            check = false;
        }
        if (!lowercasePattern.test(password)) {
            check = false;
        }
        if (!specialCharPattern.test(password)) {
            check = false;
        }
        if (!numberPattern.test(password)) {
            check = false;
        }
        if (password.length < 8) {
            check = false;
        }

        return check;
    }

    const handleKeyDown = (e, index) => {
        if (e.key === "Enter") {
            e.preventDefault(); // Evita il comportamento predefinito del form
            const nextInput = inputRefs.current[index + 1];
            if (nextInput) {
                nextInput.focus(); // Passa al campo successivo
            }
        }
    };

    if (!isVisible) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 back">
            <div className="bg-white dark:bg-gray-800 rounded-lg p-6 w-100 max-w-[90vw] text-black dark:text-white">
                <div className="flex justify-center items-center mb-6">
                    <h2 className="text-xl font-bold justify-self-center">Cambia Password</h2>
                </div>
                <div className="">
                    <div className="mb-2 grid grid-cols-2 items-center">
                        <p className="justify-self-start flex items-center">
                            Nuova password:
                            <Tooltip content="Help">
                                <button
                                    type="button"
                                    className="text-blue-500 ml-2"
                                    onClick={() => alert('La password deve contenere almeno 8 caratteri, di cui almeno una lettera maiuscola, una minuscola, un numero e un carattere speciale (es. [!@#$%^&*(),.?":{}|<>])')}
                                >
                                    <CircleHelp size={20} />
                                </button>
                            </Tooltip>
                        </p>
                        <div className="relative flex items-center">
                            <input
                                type={isNuovaPasswordVisible ? "text" : "password"}
                                placeholder=""
                                value={nuovaPassword}
                                onChange={(e) => setNuovaPassword(e.target.value)}
                                onKeyDown={(e) => handleKeyDown(e, 0)}
                                ref={(el) => (inputRefs.current[0] = el)}
                                className="rounded bg-white dark:bg-gray-800 border-2 border-gray-300 dark:border-gray-600 p-1 md:px-1 w-full"
                            />
                            <Tooltip content="Mostra password">
                                <button
                                    type="button"
                                    onClick={() => setIsNuovaPasswordVisible(!isNuovaPasswordVisible)}
                                    className="absolute right-2 text-black dark:text-white"
                                >
                                    {isNuovaPasswordVisible ? (
                                        <EyeClosed size={20} />
                                    ) : (
                                        <Eye size={20} />
                                    )}
                                </button>
                            </Tooltip>
                        </div>
                    </div>
                    <div className="mb-2 grid grid-cols-2 items-center">
                        <p className="justify-self-start">Conferma password: </p>
                        <div className="relative flex items-center ">
                            <input
                                type={isConfermaPasswordVisible ? "text" : "password"}
                                placeholder=""
                                value={confermaPassword}
                                onChange={(e) => setConfermaPassword(e.target.value)}
                                onKeyDown={(e) => handleKeyDown(e, 1)}
                                ref={(el) => (inputRefs.current[1] = el)}
                                className="rounded bg-white dark:bg-gray-800 border-2 border-gray-300 dark:border-gray-600 p-1 md:px-1 w-full"
                            />
                            <Tooltip content="Mostra password">
                                <button
                                    type="button"
                                    onClick={() => setIsConfermaPasswordVisible(!isConfermaPasswordVisible)}
                                    className="absolute right-2 text-black dark:text-white"
                                >
                                    {isConfermaPasswordVisible ? (
                                        <EyeClosed size={20} />
                                    ) : (
                                        <Eye size={20} />
                                    )}
                                </button>
                            </Tooltip>
                        </div>
                    </div>
                </div>
                <div className='mt-3 grid grid-cols-2'>
                    <button
                        onClick={closeModal}
                        className="mr-1 rounded-md py-2 px-4 bg-red-500 hover:bg-red-700 text-white font-bold"
                    >
                        Annulla
                    </button>
                    <button
                        onClick={handleConferma}
                        className="ml-1 rounded-md py-2 px-4 bg-green-500 hover:bg-green-700 text-white font-bold"
                    >
                        Conferma
                    </button>
                </div>
            </div>
        </div>
    );
};

const PopUpAzienda = ({ isVisible, setIsVisible, aziende, setAziende }) => {
    const [viewAziende, setViewAziende] = useState([]);
    const togglesRef = useRef([]);

    useEffect(() => {
        let cpViewAziende = null;
        if (isVisible) {
            isLoading = true;
            console.log(selectAziende);
            if (aziende.length === 0) {
                setViewAziende(selectAziende.filter((a) => !a["Obsoleta"]).map((a) => ({ ID: a["ID"], InvioEmail: false, Nome: a["Nome"], Checked: false })));
                cpViewAziende = selectAziende.filter((a) => !a["Obsoleta"]).map((a) => ({ ID: a["ID"], InvioEmail: false, Nome: a["Nome"], Checked: false }));
            } else {
                setViewAziende(
                    selectAziende.filter((a) => !a["Obsoleta"])
                        .map((a) => ({ ID: a["ID"], InvioEmail: false, Nome: a["Nome"], Checked: false }))
                        .map((a) => {
                            const azienda = aziende.find((azienda) => azienda["ID"] === a["ID"]);
                            return azienda ? { ...a, Checked: true, InvioEmail: azienda["InvioEmail"] } : a;
                        })
                );
                cpViewAziende = selectAziende.filter((a) => !a["Obsoleta"])
                    .map((a) => ({ ID: a["ID"], InvioEmail: false, Nome: a["Nome"], Checked: false }))
                    .map((a) => {
                        const azienda = aziende.find((azienda) => azienda["ID"] === a["ID"]);
                        return azienda ? { ...a, Checked: true, InvioEmail: azienda["InvioEmail"] } : a;
                    })
            }

            setTimeout(() => {
                cpViewAziende.forEach((a) => {
                    if (togglesRef.current[a["ID"]]) {
                        console.log(a["ID"], a["InvioEmail"], togglesRef.current[a["ID"]].getValue());
                        togglesRef.current[a["ID"]].setValue(a["InvioEmail"]);
                    }
                });
                isLoading = false;
            }, 500);
        }
    }, [isVisible]);

    const closeModal = () => {
        setIsVisible(false);
        setViewAziende([]);
    };

    const handleConferma = () => {
        setAziende(viewAziende.filter((a) => a["Checked"]));
        setIsVisible(false);
    };

    const handleToggleChange = (value, id) => {
        setViewAziende((prevAziende) => prevAziende.map((azienda) => azienda["ID"] === id ? { ...azienda, InvioEmail: value } : azienda));
    };

    if (!isVisible) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 back">
            <div className="bg-white dark:bg-gray-800 text-black dark:text-white rounded-lg p-6 w-96 max-w-[90vw]">
                <div className="flex justify-center items-center mb-6">
                    <h2 className="text-xl font-bold">Collega cliente</h2>
                </div>
                <div>
                    <div className="bg-gray-400 dark:bg-gray-600 rounded-lg grid grid-cols-2 p-2 font-bold text-center divide-x divide-black dark:divide-white">
                        <div className="grid grid-cols-1 md:flex md:items-center md:justify-center">
                            <p className="text-[2vw] md:text-base flex items-center justify-self-center">Nome</p>
                        </div>
                        <div className="grid grid-cols-1 md:flex md:items-center md:justify-center">
                            <p className="text-[2vw] md:text-base flex items-center justify-self-center">Invio Mail</p>
                        </div>
                    </div>
                    <div className="overflow-y-auto h-[30vh]">
                        {viewAziende.map((a, index) => (
                            <div
                                key={index}
                                className={`text-center rounded-lg mt-2 mb-2 grid grid-cols-2 p-2 divide-x divide-black dark:divide-white ${a["Checked"] ? "bg-blue-300 dark:bg-blue-500" : "bg-gray-300 dark:bg-gray-500"}`}
                            >
                                <div
                                    className="grid grid-cols-1 md:flex md:items-center md:justify-center cursor-pointer"
                                    onClick={() => setViewAziende((prevAziende) => prevAziende.map((azienda) => azienda["ID"] === a["ID"] ? { ...azienda, Checked: !a["Checked"] } : azienda))}
                                >
                                    <p className="text-[2vw] md:text-base flex items-center justify-self-center">{a["Nome"]}</p>
                                </div>
                                <div className="grid grid-cols-1 md:flex md:items-center md:justify-center">
                                    <ToggleSwitch ref={(el) => togglesRef.current[a["ID"]] = el} onToggleChange={(newStatus) => handleToggleChange(newStatus, a["ID"])} />
                                </div>
                            </div>
                        ))}

                    </div>
                </div>
                <div className='mt-3 grid grid-cols-2'>
                    <button
                        onClick={closeModal}
                        className="mr-1 rounded-lg py-2 px-4 bg-red-500 hover:bg-red-700 text-white font-bold"
                    >
                        Annulla
                    </button>
                    <button
                        onClick={handleConferma}
                        className="ml-1 rounded-lg py-2 px-4 bg-green-500 hover:bg-green-700 text-white font-bold"
                    >
                        Conferma
                    </button>
                </div>
            </div>
        </div>
    );
};

const PopUpUtente = ({ isVisible, setIsVisible, data }) => {
    const [nome, setNome] = useState("");
    const [cognome, setCognome] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [confermaPassword, setConfermaPassword] = useState("");
    const [aziende, setAziende] = useState([]);
    const [isPasswordVisible, setIsPasswordVisible] = useState(false);
    const [isConfermaPasswordVisible, setIsConfermaPasswordVisible] = useState(false);
    const [isPopUpAziendaVisible, setIsPopUpAziendaVisible] = useState(false);
    const [isChangePasswordVisible, setIsChangePasswordVisible] = useState(false);
    const inputRefs = useRef([]);
    const toggleRef = useRef(null);

    useEffect(() => {
        if (data && isVisible) loadAziende();
    }, [isVisible]);


    const loadAziende = async () => {
        resetData();
        try {
            isLoading = true;
            const response = await fetch('/getGestioneUtente', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    IDUtente: data["ID"],
                    CodiceDominio: infoUtente["CodiceDominio"]
                })
            });
            const responseData = await response.json();
            // console.log(responseData);
            if (response.status === 500) {
                alert(responseData.error);
                console.error(responseData.error);
                window.location.reload();
            } else {
                isLoading = false;
                if (responseData[0]["IDAzienda"] === null) {
                    setAziende([]);
                    if (toggleRef.current) {
                        toggleRef.current.setValue(responseData[0]["InvioEmail"]);
                    }
                }
                else {
                    setAziende(responseData.map((a) => ({ ID: a["IDAzienda"], InvioEmail: a["InvioEmail"], Nome: selectAziende.find((s) => s["ID"] === a["IDAzienda"])["Nome"] })));
                }
            }
        } catch (error) {
            console.error(error);
            alert("Errore nel caricamento dei clienti, riprova più tardi.");
            window.location.reload();
        }
    };

    const closeModal = () => {
        resetData();
        setIsVisible(false);
    };

    const handleConferma = async () => {
        if (data) { //modifica
            try {
                isLoading = true;
                const r1 = await fetch('/aggiornaUtente', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        ID: data["ID"],
                        Nome: nome,
                        Cognome: cognome,
                        Email: email
                    })
                });
                if (r1.status === 500) {
                    const rd1 = await r1.json();
                    alert(rd1.error);
                    console.error(rd1.error);
                }
                else {
                    if (aziende.length === 0) {
                        let toggleStatus = false;
                        if (toggleRef.current) {
                            toggleStatus = toggleRef.current.getValue();
                        }
                        const r2 = await fetch('/aggiornaGestioneTotale', {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json'
                            },
                            body: JSON.stringify({
                                CodiceDominio: infoUtente["CodiceDominio"],
                                IDUtente: data["ID"],
                                EmailUtente: email,
                                InvioMail: toggleStatus
                            })
                        });
                        if (r2.status === 500) {
                            const rd2 = await r2.json();
                            alert(rd2.error);
                            console.error(rd2.error);
                        } else {
                            isLoading = false;
                            window.location.reload();
                        }
                    }
                    else {
                        const r2 = await fetch('/aggiornaGestione', {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json'
                            },
                            body: JSON.stringify({
                                CodiceDominio: infoUtente["CodiceDominio"],
                                IDUtente: data["ID"],
                                EmailUtente: email,
                                Aziende: aziende
                            })
                        });
                        if (r2.status === 500) {
                            const rd2 = await r2.json();
                            alert(rd2.error);
                            console.error(rd2.error);
                        } else {
                            isLoading = false;
                            window.location.reload();
                        }
                    }

                }
            } catch (error) {
                alert("Errore nella modifica dell'utente, riprova più tardi.");
                console.error(error);
            }
        } else { //aggiungi
            //Controllo che la nuova password rispetti i requisiti
            if (!checkPassword(password)) {
                alert('La nuova password non rispetta i requisiti');
                setPassword('');
                setConfermaPassword('');
                return;
            }

            //Controllo che la nuova password e la conferma password siano uguali
            if (password !== confermaPassword) {
                alert('Le password non coincidono');
                setPassword('');
                setConfermaPassword('');
                return;
            }
            try {
                isLoading = true;
                const response1 = await fetch('/addUser', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        Nome: nome,
                        Cognome: cognome,
                        Email: email,
                        Password: password,
                        CodiceDominio: infoUtente["CodiceDominio"],
                        Livello: "Utente",
                        Stato: "In attesa di conferma"
                    })
                });

                if (response1.status === 500) {
                    const responseData = await response1.json();
                    alert(responseData.error);
                    console.error(responseData.error);
                } else {
                    if (aziende.length === 0) {
                        let toggleStatus = false;
                        if (toggleRef.current) {
                            toggleStatus = toggleRef.current.getValue();
                        }
                        const response2 = await fetch('/addGestioneTotale', {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json'
                            },
                            body: JSON.stringify({
                                CodiceDominio: infoUtente["CodiceDominio"],
                                EmailUtente: email,
                                InvioMail: toggleStatus
                            })
                        });

                        if (response2.status === 500) {
                            const responseData = await response2.json();
                            alert(responseData.error);
                            console.error(responseData.error);
                        } else {
                            isLoading = false;
                            window.location.reload();
                        }
                    }
                    else {
                        const response2 = await fetch('/addGestione', {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json'
                            },
                            body: JSON.stringify({
                                CodiceDominio: infoUtente["CodiceDominio"],
                                EmailUtente: email,
                                Aziende: aziende
                            })
                        });

                        if (response2.status === 500) {
                            const responseData = await response2.json();
                            alert(responseData.error);
                            console.error(responseData.error);
                        } else {
                            isLoading = false;
                            window.location.reload();
                        }
                    }
                }

            } catch (error) {
                alert("Errore nell'aggiunta dell'utente, riprova più tardi.");
                console.error(error);
            }
        }
    };

    const checkPassword = (password) => {
        let check = true;
        const uppercasePattern = /[A-Z]/;
        const lowercasePattern = /[a-z]/;
        const specialCharPattern = /[!@#$%^&*(),.?":{}|<>]/;
        const numberPattern = /[0-9]/;

        if (!uppercasePattern.test(password)) {
            check = false;
        }
        if (!lowercasePattern.test(password)) {
            check = false;
        }
        if (!specialCharPattern.test(password)) {
            check = false;
        }
        if (!numberPattern.test(password)) {
            check = false;
        }
        if (password.length < 8) {
            check = false;
        }

        return check;
    }

    const checkEmail = async () => {
        if (email === "") return;
        try {
            const response = await fetch('/checkEmail', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ Email: email }),
            });
            if (response.status === 401) {
                const data = await response.json();
                alert(data['error']);
                setEmail('');
            }
        } catch (error) {
            alert('Errore nel controllo della mail, riprovare più tardi.');
            console.log(error);
        }

    };

    const handleAdd = () => {
        setIsPopUpAziendaVisible(true);
    };

    const handleChangePassword = () => {
        setIsChangePasswordVisible(true);
    };

    const handleChangeDispositivo = async () => {
        if (!window.confirm("Sei sicuro di voler cambiare il dispositivo?")) return;
        try {
            isLoading = true;
            const response = await fetch('/deassociaDispositivo', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    ID: data["ID"]
                })
            });
            if (response.status === 500) {
                const responseData = await response.json();
                alert(responseData.error);
                console.error(responseData.error);
            } else {
                isLoading = false;
                window.location.reload();
            }
        } catch (error) {
            alert("Errore nel cambio dispositivo, riprova più tardi.");
            console.error(error);
        }
    };

    const hadleRimuoviAzienda = (id) => {
        setAziende((prevAziende) => prevAziende.filter((a) => a["ID"] !== id));
    };

    const resetData = () => {
        setNome(data ? data["Nome"] : "");
        setCognome(data ? data["Cognome"] : "");
        setEmail(data ? data["Email"] : "");
        setPassword("");
        setConfermaPassword("");
        setAziende([]);
    };

    const handleKeyDown = (e, index) => {
        if (e.key === "Enter") {
            e.preventDefault(); // Evita il comportamento predefinito del form
            const nextInput = inputRefs.current[index + 1];
            if (nextInput) {
                nextInput.focus(); // Passa al campo successivo
            }
        }
    };

    if (!isVisible) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 back">
            <div className="bg-white dark:bg-gray-800 rounded-lg p-6 w-100 max-w-[90vw]">
                <div className="flex justify-center items-center mb-6">
                    {data ? (
                        <h2 className="text-xl font-bold">Modifica Utente</h2>
                    ) : (
                        <h2 className="text-xl font-bold">Aggiungi Utente</h2>
                    )}
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 divide-y-2 md:divide-x-2 md:divide-y-0 divide-black dark:divide-white">
                    <div className="p-4">
                        <div className="grid grid-cols-2 items-center mb-2">
                            <p className="justify-self-start text-[2vw] md:text-base">Nome: </p>
                            <input
                                type="text"
                                className=" text-[2vw] md:text-base rounded bg-white dark:bg-gray-800 border-2 border-gray-300 dark:border-gray-600 p-1 md:px-1"
                                placeholder=""
                                value={nome}
                                onChange={(e) => setNome(e.target.value)}
                                onKeyDown={(e) => handleKeyDown(e, 0)}
                                ref={(el) => (inputRefs.current[0] = el)}
                            ></input>
                        </div>
                        <div className="grid grid-cols-2 items-center mb-2">
                            <p className="justify-self-start text-[2vw] md:text-base">Cognome: </p>
                            <input
                                type="text"
                                className=" text-[2vw] md:text-base rounded bg-white dark:bg-gray-800 border-2 border-gray-300 dark:border-gray-600 p-1 md:px-1"
                                placeholder=""
                                value={cognome}
                                onChange={(e) => setCognome(e.target.value)}
                                onKeyDown={(e) => handleKeyDown(e, 1)}
                                ref={(el) => (inputRefs.current[1] = el)}
                            ></input>
                        </div>
                        <div className="grid grid-cols-2 items-center mb-2">
                            <p className="justify-self-start text-[2vw] md:text-base">Email: </p>
                            <input
                                type="text"
                                className=" text-[2vw] md:text-base rounded bg-white dark:bg-gray-800 border-2 border-gray-300 dark:border-gray-600 p-1 md:px-1"
                                placeholder=""
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                onBlur={checkEmail}
                                onKeyDown={(e) => handleKeyDown(e, 2)}
                                ref={(el) => (inputRefs.current[2] = el)}
                            ></input>
                        </div>
                        {data ? (
                            <>
                                {
                                    data["DataDeassociazione"] === null && data["CodiceDispositivo"] !== null ? (
                                        <>
                                            <div className='flex justify-center grid grid-cols-2 gap-1 md:gap-4'>
                                                <button className="text-[2vw] md:text-base bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-2 rounded mt-4" onClick={handleChangeDispositivo}>
                                                    Cambia Dispositivo
                                                </button>
                                                <button className="text-[2vw] md:text-base bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-2 rounded mt-4" onClick={handleChangePassword}>
                                                    Cambia Password
                                                </button>
                                            </div>
                                        </>
                                    ) : (
                                        <>
                                            <div className='flex justify-center md:gap-4'>
                                                <button className="text-[2vw] md:text-base bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-2 rounded mt-4" onClick={handleChangePassword}>
                                                    Cambia Password
                                                </button>
                                            </div>
                                        </>
                                    )
                                }
                            </>
                        ) : (
                            <>
                                <div className="grid grid-cols-2 items-center mb-2">
                                    <p className="justify-self-start flex items-center text-[2vw] md:text-base">
                                        Password:
                                        <Tooltip content="Help">
                                            <button
                                                type="button"
                                                className="text-blue-500 ml-2"
                                                onClick={() => alert('La password deve contenere almeno 8 caratteri, di cui almeno una lettera maiuscola, una minuscola, un numero e un carattere speciale (es. [!@#$%^&*(),.?":{}|<>])')}
                                            >
                                                <CircleHelp size={20} />
                                            </button>
                                        </Tooltip>
                                    </p>
                                    <div className="relative flex items-center">
                                        <input
                                            type={isPasswordVisible ? "text" : "password"}
                                            placeholder=""
                                            value={password}
                                            onChange={(e) => setPassword(e.target.value)}
                                            onKeyDown={(e) => handleKeyDown(e, 3)}
                                            ref={(el) => (inputRefs.current[3] = el)}
                                            className=" text-[2vw] md:text-base rounded bg-white dark:bg-gray-800 border-2 border-gray-300 dark:border-gray-600 p-1 md:px-1 w-full"
                                        />
                                        <Tooltip content="Mostra password">
                                            <button
                                                type="button"
                                                onClick={() => setIsPasswordVisible(!isPasswordVisible)}
                                                className="locked absolute right-2 text-black dark:text-white"
                                            >
                                                {isPasswordVisible ? (
                                                    <EyeClosed size={20} />
                                                ) : (
                                                    <Eye size={20} />
                                                )}
                                            </button>
                                        </Tooltip>
                                    </div>
                                </div>
                                <div className="mb-2 grid grid-cols-2 items-center">
                                    <p className="justify-self-start text-[2vw] md:text-base">Conferma password: </p>
                                    <div className="relative flex items-center ">
                                        <input
                                            type={isConfermaPasswordVisible ? "text" : "password"}
                                            placeholder=""
                                            value={confermaPassword}
                                            onChange={(e) => setConfermaPassword(e.target.value)}
                                            onKeyDown={(e) => handleKeyDown(e, 4)}
                                            ref={(el) => (inputRefs.current[4] = el)}
                                            className="text-[2vw] md:text-base rounded bg-white dark:bg-gray-800 border-2 border-gray-300 dark:border-gray-600 p-1 md:px-1 w-full"
                                        />
                                        <Tooltip content="Mostra password">
                                            <button
                                                type="button"
                                                onClick={() => setIsConfermaPasswordVisible(!isConfermaPasswordVisible)}
                                                className="absolute right-2 text-black dark:text-white"
                                            >
                                                {isConfermaPasswordVisible ? (
                                                    <EyeClosed size={20} />
                                                ) : (
                                                    <Eye size={20} />
                                                )}
                                            </button>
                                        </Tooltip>
                                    </div>
                                </div>
                            </>
                        )}

                    </div>
                    <div className="p-4">
                        <div className='flex justify-center'>
                            <button className="mr-1 rounded-lg bg-blue-500 hover:bg-blue-700 text-white font-bold p-2" onClick={handleAdd}>
                                Collega cliente
                            </button>
                        </div>
                        <div className="grid grid-cols-2 md:grid-cols-3 items-center mb-2 p-4 text-center gap-2">
                            {
                                aziende.length === 0 ? (
                                    <>
                                        <div className="col-span-3 bg-gray-300 dark:bg-gray-500 border-solid border-2 border-black p-2 rounded">
                                            Utente abilitato su tutti i clienti<br />
                                            <div className="grid grid-cols-2 items-center">
                                                <p className="justify-self-start">Invio delle mail: </p>
                                                <div className="justify-self-end">
                                                    <ToggleSwitch ref={toggleRef} />
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                ) : (
                                    aziende.map((a, index) => (
                                        a["InvioEmail"] ? (
                                            <>
                                                <div key={index} className="grid grid-cols-1 items-center bg-gray-300 dark:bg-gray-500 border-solid border-2 border-green-500 p-1 rounded">
                                                    {a["Nome"]}
                                                    <Tooltip content="Rimuovi">
                                                        <button className="justify-self-center text-red-500 dark:text-red-700" onClick={() => hadleRimuoviAzienda(a["ID"])}><X size={15} /></button>
                                                    </Tooltip>
                                                </div>
                                            </>
                                        ) : (
                                            <>
                                                <div key={index} className="grid grid-cols-1 items-center bg-gray-300 dark:bg-gray-500 border-solid border-2 border-red-500 p-1 rounded">
                                                    {a["Nome"]}
                                                    <Tooltip content="Rimuovi">
                                                        <button className="justify-self-center text-red-500 dark:text-red-700" onClick={() => hadleRimuoviAzienda(a["ID"])}><X size={15} /></button>
                                                    </Tooltip>
                                                </div>
                                            </>
                                        )
                                    ))
                                )
                            }
                        </div>
                    </div>
                </div>
                <div className='mt-3 grid grid-cols-2'>
                    <button
                        onClick={closeModal}
                        className="mr-1 rounded-lg py-2 px-4 bg-red-500 hover:bg-red-700 text-white font-bold"
                    >
                        Annulla
                    </button>
                    <button
                        onClick={handleConferma}
                        className="ml-1 rounded-lg py-2 px-4 bg-green-500 hover:bg-green-700 text-white font-bold"
                    >
                        Conferma
                    </button>
                </div>
            </div >
            <PopUpAzienda isVisible={isPopUpAziendaVisible} setIsVisible={setIsPopUpAziendaVisible} aziende={aziende} setAziende={setAziende} />
            <PopUpChangePassword isVisible={isChangePasswordVisible} setIsVisible={setIsChangePasswordVisible} data={data} />
        </div >
    );
};

const TableRow = ({ data, eliminazioniRimaste, utentiDisponibili }) => {
    const [isVisible, setIsVisible] = useState(false);

    const handleElimina = async () => {
        if (!window.confirm("Sei sicuro di voler eliminare l'utente?")) return;
        try {
            isLoading = true;
            const response = await fetch('/eliminaUser', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    ID: data["ID"],
                    CodiceDominio: infoUtente["CodiceDominio"],
                    EliminazioniRimaste: eliminazioniRimaste - 1
                })
            });
            if (response.status === 500) {
                const responseData = await response.json();
                alert(responseData.error);
                console.error(responseData.error);
            } else {
                isLoading = false;
                window.location.reload();
            }
        } catch (error) {
            alert("Errore nell'eliminazione dell'utente, riprova più tardi.");
            console.error(error);
        }
    };

    const handleRecupera = async () => {
        if (utentiDisponibili === 0) {
            alert("Per recuperare l'utente è necessario avere almeno un utente disponibile");
            return;
        }

        if (!window.confirm("Sei sicuro di voler recuperare l'utente?")) return;

        try {
            isLoading = true;
            const response = await fetch('/recuperaUser', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    ID: data["ID"]
                })
            });
            if (response.status === 500) {
                const responseData = await response.json();
                alert(responseData.error);
                console.error(responseData.error);
            } else {
                isLoading = false;
                window.location.reload();
            }

        } catch (error) {
            alert("Errore nel recupero dell'utente, riprova più tardi.");
            console.error(error);
        }
    };

    return (
        <div className="grid grid-cols-7 gap-1 md:gap-4 mt-2">
            <div></div>
            <div className="col-span-5 bg-gray-300 dark:bg-gray-500 rounded-lg grid grid-cols-5 p-4 text-center divide-x divide-black dark:divide-white break-words">
                <div>{data["Nome"]}</div>
                <div>{data["Cognome"]}</div>
                <div>{data["Email"]}</div>
                <div>{data["Stato"]}</div>
                <div>{data["CodiceDispositivo"] === null ? ("-----") : data["CodiceDispositivo"]}</div>
            </div>
            <div className="flex items-center gap-1">
                {data["DataEliminazione"] === null ? (
                    <>
                        <Tooltip content="Modifica">
                            <button className="text-blue-500" onClick={() => setIsVisible(true)}>
                                <Pen size={24} />
                            </button>
                        </Tooltip>
                        {eliminazioniRimaste > 0 ? (
                            <Tooltip content="Elimina">
                                <button className="text-red-500" onClick={handleElimina}>
                                    <Trash2 size={24} />
                                </button>
                            </Tooltip>
                        ) : null}
                    </>
                ) : (
                    <>
                        <Tooltip content="Recupera">
                            <button className="text-blue-500" onClick={handleRecupera}>
                                <History size={24} />
                            </button>
                        </Tooltip>
                    </>
                )}
            </div>
            <PopUpUtente isVisible={isVisible} setIsVisible={setIsVisible} data={data} />
        </div>
    );
};

const UtentiManager = () => {
    const navigate = useNavigate();
    const [indexTabella, setIndexTabella] = useState([
        { value: "Nome", dbCode: "Nome", ascending: true, filter: "text" },
        { value: "Cognome", dbCode: "Cognome", ascending: true, filter: "text" },
        { value: "Email", dbCode: "Email", ascending: true, filter: "text" },
        { value: "Stato", dbCode: "Stato", ascending: true, filter: "text" },
        { value: "Dispositivo", dbCode: "CodiceDispositivo", ascending: true, filter: "text" }
    ]);
    const [filters, setFilters] = useState({
        Nome: "",
        Cognome: "",
        Email: "",
        Stato: "",
        Dispositivo: ""
    });
    const [data, setData] = useState([]);
    const [viewData, setViewData] = useState([]);
    const [isVisible, setIsVisible] = useState(false);
    const [archive, setArchive] = useState(false);
    const [utentiDisponibili, setUtentiDisponibili] = useState(0);
    const [eliminazioniRimaste, setEliminazioniRimaste] = useState(0);

    useEffect(() => {
        onload();
    }, []);

    useEffect(() => {
        setViewData(data.filter((d) => archive ? d.value["DataEliminazione"] !== null : d.value["DataEliminazione"] === null));
    }, [data]);

    useEffect(() => {
        let newData = [...data];
        for (const key in filters) {
            if (filters[key] !== "") {
                newData = newData.filter((d) => (d.value[key] !== null ? d.value[key].toString().toLowerCase().includes(filters[key].toLowerCase()) : null));
            }
        };
        setViewData(newData.filter((d) => archive ? d.value["DataEliminazione"] !== null : d.value["DataEliminazione"] === null));
    }, [filters]);

    const onload = async () => {
        let dataCopy = [];
        //getInfoUtente
        // isLoading = true;
        try {

            await loadNav();

            //loadDati
            const r2 = await fetch('/getUtenti', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    CodiceDominio: infoUtente["CodiceDominio"]
                })
            });
            const rd2 = await r2.json();
            if (r2.status === 500) {
                alert(rd2.error);
                console.error(rd2.error);
                navigate("/dashManager");
            } else {
                setData(rd2.map(item => ({ value: item })));
                dataCopy = rd2.map(item => ({ value: item }));

                //loadSelectAziende
                const r3 = await fetch('/getAziende', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        CodiceDominio: infoUtente["CodiceDominio"]
                    })
                });
                const rd3 = await r3.json();
                if (r3.status === 500) {
                    alert(rd3.error);
                    console.error(rd3.error);
                    navigate("/dashManager");
                } else {
                    selectAziende = rd3.filter((d) => d["Obsoleta"] === false);

                    //calcolo utenti disponibili e eliminazioni rimaste
                    const r4 = await fetch('/getInfoPiano', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({
                            CodiceDominio: infoUtente["CodiceDominio"]
                        })
                    });
                    const rd4 = await r4.json();
                    if (r4.status === 500) {
                        alert(rd4.error);
                        console.error(rd4.error);
                        navigate("/dashManager");
                    } else {
                        if (rd4[0]["NumeroUtenti"] === 99) {
                            setUtentiDisponibili(99);
                        } else {
                            //utenti = numeroUtenti - utentiAttivi
                            let utentiAttivi = dataCopy.filter((d) => d.value["DataEliminazione"] === null).length;
                            // console.log(utentiAttivi); 
                            setUtentiDisponibili(rd4[0]["NumeroUtenti"] - utentiAttivi);
                        }

                        const r5 = await fetch('/getDominio', {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json'
                            },
                            body: JSON.stringify({
                                CodiceDominio: infoUtente["CodiceDominio"]
                            })
                        });
                        const rd5 = await r5.json();
                        if (r5.status === 500) {
                            alert(rd5.error);
                            console.error(rd5.error);
                            navigate("/dashManager");
                        } else {
                            isLoading = false;
                            setEliminazioniRimaste(rd5[0]["EliminazioniUtentiRimaste"]);
                        }
                    }
                }

            }
        } catch (error) {
            alert("Errore nel caricamento della pagina, riprova più tardi");
            console.log(error);
            navigate("/dashManager");
        }
        isLoading = false;
    };

    const sortByColumn = (column) => {
        setIndexTabella((prevIndexTabella) =>
            prevIndexTabella.map((d) =>
                d.dbCode === column ? { ...d, ascending: !d.ascending } : d
            )
        );
        const isAscending = indexTabella.find((d) => d.dbCode === column)?.ascending;
        let newData = [...viewData];

        newData.sort((a, b) => {
            if (a.value[column] > b.value[column]) return isAscending ? -1 : 1;
            if (a.value[column] < b.value[column]) return isAscending ? 1 : -1;
            return 0;
        });

        setViewData(newData);
    };

    const handleArchive = () => {
        const newArchive = !archive;
        setArchive(newArchive);
        let newData = [...data];
        newData = newData.filter((d) => newArchive ? d.value["DataEliminazione"] !== null : d.value["DataEliminazione"] === null);
        setViewData(newData);
    };

    const handleAdd = () => {
        setIsVisible(true);
    };

    return (
        <div className="min-h-screen bg-white dark:bg-gray-800">
            <NavBar page="UTENTI" />
            {isLoading && <Loader />}
            <div className="p-4 bg-white dark:bg-gray-800 text-black dark:text-white">
                <div className="grid grid-cols-1 md:grid-cols-2 divide-y-2 md:divide-x-2 md:divide-y-0 divide-black dark:divide-white mt-14">
                    <div className="flex justify-self-center md:justify-self-end font-bold text-xl pb-2 md:pb-0 md:pr-4">
                        {utentiDisponibili === 99 ? (<>Utenti illimitati</>) : (<>Utenti rimasti: {utentiDisponibili}</>)}
                    </div>
                    <div className="flex justify-self-center md:justify-self-start font-bold text-xl pt-2 md:pt-0 md:pl-4">
                        Eliminazione di utenti rimasti : {eliminazioniRimaste}
                    </div>
                </div>
                {utentiDisponibili > 0 ? <div className='flex justify-center'>
                    <button className="bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded mt-4" onClick={handleAdd}>
                        Aggiungi Utente
                    </button>
                </div> : null}
                <div id="tabella">
                    <div className="grid grid-cols-7 gap-4 mt-4">
                        <div></div>
                        <div className="col-span-5 bg-gray-400 dark:bg-gray-600 rounded-lg grid grid-cols-5 p-4 font-bold text-center divide-x divide-black dark:divide-white">
                            {
                                indexTabella.map((d, index) => (
                                    <div key={index} onClick={() => sortByColumn(d.dbCode)} className="hover:cursor-pointer grid grid-cols-1 md:flex md:items-center md:justify-center">
                                        <p className="text-[2vw] md:text-base flex items-center justify-self-center">{d.value}</p>
                                        <Tooltip content="Ordina">
                                            <button className="ml-2 text-gray-500 dark:text-gray-700 justify-self-center">
                                                {d.ascending ? <ArrowDownAZ size={24} /> : <ArrowUpAZ size={24} />}
                                            </button>
                                        </Tooltip>
                                    </div>
                                ))
                            }
                        </div>
                        <div></div>
                    </div>
                    <div className="grid grid-cols-7 gap-4 mt-2">
                        <div></div>
                        <div className="col-span-5 rounded-lg grid grid-cols-5 p-4 font-bold text-center divide-x divide-black dark:divide-white">
                            {
                                indexTabella.map((d, index) => (
                                    <div key={index} className={`flex items-center justify-center ${index === 0 ? "mr-2" : index === 4 ? "pl-2" : "px-2"}`}>
                                        <input
                                            type={d.filter}
                                            placeholder={d.value}
                                            value={filters[d.dbCode]}
                                            className="text-[2vw] md:text-base rounded bg-gray-100 dark:bg-gray-300 border-2 border-gray-200 dark:border-gray-400 p-1 md:px-1 text-center w-full"
                                            onChange={(e) => setFilters({ ...filters, [d.dbCode]: e.target.value })}
                                        />
                                    </div>
                                ))
                            }
                        </div>
                        <div className='flex items-center'>
                            <Tooltip content="Archivio">
                                <button className={!archive ? "text-yellow-700" : "text-yellow-300"} onClick={handleArchive}>
                                    <History size={24} />
                                </button>
                            </Tooltip>
                        </div>
                    </div>
                    {viewData.map((d, index) => (
                        <TableRow key={index} data={d.value} eliminazioniRimaste={eliminazioniRimaste} utentiDisponibili={utentiDisponibili} />
                    ))}
                </div>
                <PopUpUtente isVisible={isVisible} setIsVisible={setIsVisible} />
            </div>
        </div>
    );
};

export default UtentiManager;